import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_DOUBLE_OPTIN_ENABLED_NEW_USER = createFcmDetails('double_optin_enabled_new_user', {
	owner: 'Modern Petitioning Pack',
	context: 'Start a Petition GDPR flow',
	description: 'This country feature config prompts the user to verify their email.',
	import: false,
});
